import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "survey-dsop-template"
const DEFAULT_TEMPLATE = "dsop"
const ALLOWED_TEMPLATES = [ "dsop", "light", "dark", "retro", "blue_horizon", "orange_sunset_sky", "mellow_morning_toast" ]

export default class extends Controller {
  static targets = [ "select" ]
  static values = {
    initialTemplate: String,
    persistSelection: { type: Boolean, default: true }
  }

  connect() {
    const initialTemplate = this.resolveInitialTemplate()

    this.applyTemplate(initialTemplate)
    if (this.hasSelectTarget) this.selectTarget.value = initialTemplate
  }

  changeTemplate(event) {
    const requestedTemplate = event.target.value
    const safeTemplate = ALLOWED_TEMPLATES.includes(requestedTemplate) ? requestedTemplate : DEFAULT_TEMPLATE

    this.applyTemplate(safeTemplate)
    if (this.persistSelectionValue) localStorage.setItem(STORAGE_KEY, safeTemplate)
  }

  readSavedTemplate() {
    try {
      return localStorage.getItem(STORAGE_KEY)
    } catch (_error) {
      return DEFAULT_TEMPLATE
    }
  }

  applyTemplate(templateName) {
    document.documentElement.dataset.template = templateName
    this.syncThemeColorMeta()
  }

  resolveInitialTemplate() {
    const configuredTemplate = this.initialTemplateValue
    if (ALLOWED_TEMPLATES.includes(configuredTemplate)) return configuredTemplate

    const savedTemplate = this.readSavedTemplate()
    return ALLOWED_TEMPLATES.includes(savedTemplate) ? savedTemplate : DEFAULT_TEMPLATE
  }

  syncThemeColorMeta() {
    const themeMeta = document.querySelector('meta[name="theme-color"]')
    if (!themeMeta) return

    const computedPrimary = getComputedStyle(document.documentElement)
      .getPropertyValue("--template-primary")
      .trim()

    if (computedPrimary) themeMeta.setAttribute("content", computedPrimary)
  }
}
